import bluebirdRecap from './bluebirdRecap.mp4';
const Videos = {
	'bluebirdRecap': bluebirdRecap
};

export default Videos;
